import { solicitorsActions } from './solicitors-slice'
import store from './index'
import { handleError, handleSessionExpired } from './error-handler';

export const fetchSolicitorsList = () => {
    return async (dispatch) => {
        const fetchData = async () => {
            dispatch(solicitorsActions.setIsLoading(true))
            var bearer = 'Bearer ' + localStorage.getItem('token');
            const url = store.getState().auth.url
            const response = await fetch(url + 'api/solicitors',{
                headers:{
                    'Authorization': bearer,
                }
            });

            if (!response.ok) {
                if(response.status === 401){ 
                    handleSessionExpired(dispatch, bearer)
                    throw new Error('Your session has expired. Please log in again.')
                }
                else{ throw new Error('Could not fetch solicitors list.') }
            }
            const data = await response.json()
            return data;
        };

        try {
            const solicitorsData = await fetchData()
            dispatch(solicitorsActions.loadSolicitors({ solicitors: solicitorsData || [] }))
            dispatch(solicitorsActions.setIsLoading(false))
        } catch (error) {
            handleError(dispatch, error)
        }
    };
};

export const setSolicitorsIsLoading = (value) => {
    return (dispatch) => {
        dispatch(solicitorsActions.setIsLoading(value))
    }
}

